import { Controller } from "@hotwired/stimulus"

// Type-the-name-to-confirm gate for destructive actions. Submit stays
// disabled until the input matches the expected value (case-insensitive).
export default class extends Controller {
  static targets = ["input", "submit"]
  static values = { expected: String }

  check() {
    const match =
      this.inputTarget.value.trim().toLowerCase() ===
      this.expectedValue.trim().toLowerCase()
    this.submitTarget.disabled = !match
  }
}
